import Accordion from "@/common/components/Accordion";
import { Control, Controller, FieldErrors, UseFormRegister, useWatch } from "react-hook-form";
import { CreateScrapRuleSchema } from "../../schemas/maintenanceScrapRules/createScrapRule.schema";
import Checkbox from "@/common/components/Checkbox";
import { UnitTextField } from "@/common/components/UnitTextField";
import { unitStrategy } from "@/features/privateCompanies/constants/unitStrategy.constant";

interface AccordionScrapRulesExecutionRulesProps {
  register: UseFormRegister<CreateScrapRuleSchema>
  errors: FieldErrors<CreateScrapRuleSchema>
  control: Control<CreateScrapRuleSchema>
  disabled?: boolean
}

export default function AccordionScrapRulesExecutionRules({register, errors, control, disabled}: AccordionScrapRulesExecutionRulesProps) {
  const [has_mileage, has_hours, has_years] = useWatch({
    control,
    name: ['has_mileage', 'has_hours', 'has_years']
  })

  return (
    <Accordion
      name="scrapRulesExecutionRules"
      head={<p className="text-base">Regras para execução do desfazimento</p>}
      body={
        <div className="flex flex-col gap-4">
          <Checkbox
            label="Quilometragem máxima"
            {...register('has_mileage')}
            disabled={disabled}
          />
          <Checkbox
            label="Hora uso máximo"
            {...register('has_hours')}
            disabled={disabled}
          />
          <Checkbox
            label="Tempo máximo de utilização em anos"
            {...register('has_years')}
            disabled={disabled}
          />
          {has_mileage && (
            <Controller
              control={control}
              name="maximum_mileage_condition"
              render={({ field }) => (
                <UnitTextField
                  {...field}
                  key='mileage-input'
                  decimals={0}
                  unit={unitStrategy.kilometers}
                  maxValue={99_999_999}
                  label="Quilometragem máxima"
                  errorMessage={errors?.maximum_mileage_condition?.message}
                  disabled={disabled}
                />
              )}
            />
          )}
          {has_hours && (
            <Controller
              control={control}
              name="maximum_usage_hours_condition"
              render={({ field }) => (
                <UnitTextField
                  {...field}
                  key="hours-input"
                  decimals={0}
                  unit={unitStrategy.hours}
                  maxValue={99_999_999}
                  label="Hora uso máximo"
                  errorMessage={errors?.maximum_usage_hours_condition?.message}
                  disabled={disabled}
                />
              )}
            />
          )}
          {has_years && (
            <Controller
              control={control}
              name="maximum_usage_time_in_years_condition"
              render={({ field }) => (
                <UnitTextField
                  {...field}
                  key='years-input'
                  decimals={0}
                  maxValue={99_999_999}
                  label="Tempo máximo de utilização em anos"
                  errorMessage={errors?.maximum_usage_time_in_years_condition?.message}
                  disabled={disabled}
                />
              )}
            />
          )}
        </div>
      }
    />
  )
}
